import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { queryElectricity as _queryElectricity } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterLineChart from '@/components/biChart/waterLineChartSx';
import yearRange from '@/components/date/yearRange';
import weekRange from '@/components/date/weekRange';
export default {
  name: 'lineAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterLineChart: waterLineChart,
    yearRange: yearRange,
    weekRange: weekRange
  },
  data: function data() {
    return {
      initNum: 0,
      reportType: '0',
      factorCategory: '11',
      factorCode: '',
      limitSelectDate: {},
      stime: '',
      etime: '',
      quantum: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      powerList: [],
      siteId: window.sessionStorage.getItem('siteId')
    };
  },
  created: function created() {
    var myDate = new Date(); //获取当前年份(2位)

    var year = myDate.getFullYear(); //获取完整的年份(4位,1970-????)

    var month = myDate.getMonth(); //获取当前月份(0-11,0代表1月)

    var day = myDate.getDate(); //获取当前日(1-31)

    var dayNow = year + '-' + (month + 1) + '-' + day;
    this.dayNow = dayNow;
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    }; // this.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
    // this.etime = this.limitSelectDate.max.format('YYYY-MM-DD')

    this.stime = dayNow;
    this.etime = dayNow;
    this.queryElectricity();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {},
    siteId: function siteId(val, oldVal) {
      console.log(val, oldVal);

      if (val != oldVal) {
        this.queryElectricity();
      }
    }
  },
  filters: {
    weekFormat: function weekFormat(val) {
      var week = '';

      switch (val) {
        case 1:
          week = '周一';
          break;

        case 2:
          week = '周二';
          break;

        case 3:
          week = '周三';
          break;

        case 4:
          week = '周四';
          break;

        case 5:
          week = '周五';
          break;

        case 6:
          week = '周六';
          break;

        case 7:
          week = '周日';
          break;
      }

      return week;
    },
    monthFormat: function monthFormat(date) {
      var time = new Date(date);
      var month = time.getMonth() + 1;
      month = month > 9 ? month : '0' + month;
      return time.getFullYear() + '-' + month;
    },
    dayFormat: function dayFormat(time) {
      var date = time.split(' ');
      var dateTime = date[1].split(':');
      return date[0] + ' ' + dateTime[0];
    }
  },
  methods: {
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    queryElectricity: function queryElectricity() {
      var _this = this;

      _queryElectricity({
        siteId: window.sessionStorage.getItem('siteId') || ''
      }).then(function (res) {
        if (res.success) {
          _this.powerList = res.result;
          _this.factorCode = res.result[0].code;
        }
      });
    },
    onMonthRangeChange: function onMonthRangeChange(value) {
      this.stime = moment(value[0]).format('YYYY-MM');
      this.etime = moment(value[1]).format('YYYY-MM');
    },
    handleRangeChange: function handleRangeChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1]; // console.log('实时数据/日数据', dateString)
    },
    dataChartChange: function dataChartChange(e) {
      this.factorCategory = e.target.value;

      if (this.factorCategory == '13') {
        this.queryElectricity();
      }
    },
    factorCodeChange: function factorCodeChange(e) {
      this.factorCode = e.target.value;
    },
    dataTypeChange: function dataTypeChange(e) {
      this.reportType = e.target.value;

      if (e.target.value == '3') {
        this.stime = this.limitSelectDate.min.format('YYYY-MM');
        this.etime = this.limitSelectDate.max.format('YYYY-MM');
      } else if (e.target.value == '2' || e.target.value == '0') {
        this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
      } else if (e.target.value == '1') {
        this.stime = this.dayNow;
        this.etime = this.dayNow;
      }
    },
    getWeek: function getWeek(dt) {
      var d1 = new Date(dt);
      var d2 = new Date(dt);
      d2.setMonth(0);
      d2.setDate(1);
      var rq = d1 - d2;
      var days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      var num = Math.ceil(days / 7);
      return num + 1;
    },
    onWeekRangeChange: function onWeekRangeChange(value) {
      console.log('周区间', value);
      this.stime = value[0];
      this.etime = value[1];
    },
    onYearRangeChange: function onYearRangeChange(value) {
      console.log('季/年区间', value);
      this.stime = value[0] + '';
      this.etime = value[1] + '';
    },
    onallChange: function onallChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1];
      console.log('实时数据/日数据', dateString);
    },
    onallDateChange: function onallDateChange(date, dateString) {
      this.stime = dateString;
      this.etime = dateString;
      console.log('实时数据/日数据', dateString);
    }
  }
};